module.exports = __webpack_public_path__ + "static/img/logoBlack.80cdfc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoBlack.png
// module id = t3/N
// module chunks = 25